import { isIdXboxGameInformationDetailsFormValid } from "../../../../helpers/formValidation";
import { GameInformationConceptDetailsDataType, SubFormsDataTypes } from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const DetailsDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const detailsData = data as GameInformationConceptDetailsDataType;
    if (!detailsData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationDetailsFormValid(detailsData);
    return { result: validSchema };
  },
};
